import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Fetch from '../components/Fetch';
import ArticleList from '../components/ArticleList';

export default function SearchResult() {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get('q')?.toLowerCase() || '';
    setSearchQuery(query);
  }, [location.search]);

  return (
    <div className="p-4 search-result">
      <h1>Search Results for <span>"{searchQuery}"</span></h1>
      <Fetch>
        {({ data, loading, error }) => {
          if (loading) return <div>Loading...</div>;
          if (error) return <div>Error loading results</div>;

          const filtered = data?.filter(item => {
            const isVideoSearch = searchQuery === 'video';
            const matchesTitle = item.article_title?.toLowerCase().includes(searchQuery);
            const matchesTags = item.tags?.some(tag => tag.toLowerCase().includes(searchQuery));
            
            if (isVideoSearch) {
              return item.content_type === 'igtt';
            }
            return matchesTitle || matchesTags;
          }) || [];

          return (
            <>
              {filtered.length > 0 ? (
                <ArticleList articles={filtered} />
              ) : (
                <div>No results found</div>
              )}
            </>
          );
        }}
      </Fetch>
    </div>
  );
}